///////////////////////////////////////////////////////////// PRE BOOMERANG
import packageJson from '../../../../package.json';

export const environment = {
  brand: 'vuelaonline',
  production: false,
  domain: 'https://vuelaonline.navisk.com',
  domainWithBrand: 'https://vuelaonline.navisk.com/vuelaonline',
  domainStatics: 'https://webapiservicevuelaonline.navisk.com',
  apidomain: 'https://webapiservicevuelaonline.navisk.com/api/',
  googlekey: null,
  youtubeList: null,
  recaptchakey: '6LcKYOUUAAAAAPiqu-Zke2vovQSYBztEKTb6qXi9',
  googleSiteVerification: '7thXmbmaTL41JjfSUh-KtDjagJzZSTBsNI5Bw8xEKkk',
  chat: {
    api: null,
    socket: null,
  },
  defaultLang: 'es',
  myMessages: true,
  allowedVideo: false,
  allowedManagerUsers: true,
  allowedPaymentLinks: false,
  version: packageJson.version,
};

console.log(environment.apidomain);
